export default "__VITE_ASSET__CqzX2p8p__"